import { setTaskInfo } from "../../redux/taskSlice";

const SetTaskInfo = (reference, tree_node_id_ref) => {
  // Use window.__REDUX_STORE__ to avoid circular dependency with store.js
  const store = window.__REDUX_STORE__;
  if (store) {
    store.dispatch(setTaskInfo({ reference, tree_node_id_ref }));
  } else {
    console.debug("Redux store not yet available in SetTaskInfo");
  }
};

export default SetTaskInfo;
